import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import ErrorModal from '@/component/common/modal/ErrorModal';
import { getTicketListQuery } from '@/service/ticketService';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { I18n } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import Filters from './Filters';
import ViewTabs from './ViewTabs';
import ListTicket from '../List';
import '../Ticket.css';
import { createKibanaData } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';

export default function QAListTicket(props) {
    const [updatedTicket, setUpdatedTicket] = useState({});
    
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const [ticketList, setTicketList] = useState([]);

    const [contractType, setContractType] = useState(1);
    const [isCreateTicket, setIsCreateTicket] = useState(false);
    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    const [fileUploading, setFileUploading] = useState({});

    // view selected
    const [viewSelected, setViewSelected] = useState(Constant.CUSTOMER_SIDE_VIEW.IN_CHARGE_QA_VIEW);

    // filter status
    const [filterStatus, setFilterStatus] = useState(Constant.QA_FILTER_STATUS.SENT);

    // filter creator
    const [filterCreator, setFilterCreator] = useState(Constant.QA_FILTER_CREATOR.PROJECT_MEMBER);

    // filter helpDesk
    const [filterHelpDesk, setFilterHelpDesk] = useState('');

    const [helpDeskListInView, setHelpDeskListInView] = useState([]);

    const [filterHelpDeskNotice, setFilterHelpDeskNotice] = useState('');

    const [filterTelephonePublisher, setFilterTelephonePublisher] = useState('');

    // helpDesk list
    const [helpDeskList, setHelpDeskList] = useState([]);

    const [triggerInterval, setTriggerInterval] = useState('');

    const [lastedCountList, setLastedCountList] = useState(0);

    const [ticketFrom, setTicketFrom] = useState(0);

    const [isScrollLoad, setIsScrollLoad] = useState(false);
    const [totalTickets, setTotalTickets] = useState(0);

    useEffect(() => {
        const controller1 = new AbortController();
        if (!Utils.isEmptyObject(projectInuseDetail)) {
            setTicketFrom(0);
            getTicketLists(true);
        }

        return () => {
            controller1.abort();
        }
    }, [
        props.ticketListType,
        projectInuseDetail,
        viewSelected,
        filterStatus,
        filterCreator,
        filterHelpDesk,
        filterHelpDeskNotice,
        filterTelephonePublisher,
    ]);

    // Handle get ticketLists when triggerReload
    useEffect(() => {
        const controller2 = new AbortController();
        if (!props.triggerReload) return;

        const size = Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD + ticketFrom;
        // reset loading
        setIsScrollLoad(true);
        getTicketLists(true, 0, size);

        return () => {
            controller2.abort();
        }
    }, [props.triggerReload]);

    // create interval trigger reload panel
    useEffect(() => {
        setContractType(corporationDetail.contractType);
    
        const isDev = process.env.NODE_ENV === 'development';
        const appDomain = process.env.REACT_APP_DOMAIN_NAME || '';
        const isTestDomain = appDomain.includes('dbdesk-test.ominext.dev');
        const baseInterval = 60000;
        const timeInterval = isTestDomain ? baseInterval * 10 : baseInterval;
    
        let intervalId = null;
    
        if (!isDev) {
            intervalId = setInterval(() => {
                setTriggerInterval(Date.now().toString());
            }, timeInterval);
        }
    
        return () => {
            if (intervalId) clearInterval(intervalId);
    
            // Clear cached data
            setHelpDeskListInView([]);
            setTicketList([]);
            setHelpDeskList([]);
            setUpdatedTicket({});
        };
    }, []);

    // handle reload panel when triggerInterval
    useEffect(() => {
        const controller3 = new AbortController();
        if (!Utils.isEmptyObject(projectInuseDetail) && triggerInterval) {
            const size = Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD + ticketFrom;
            setIsScrollLoad(true);
            getTicketLists(false, 0, size);
        }

        return () => {
            controller3.abort();
        }
    }, [triggerInterval]);

    useEffect(() => {
        const isShowButtonCreateTicket = () => {
            if (Utils.isProjectGuest(projectInuseDetail)) {
                return !(
                    Utils.isGuestUser(userDetail) &&
                    props.ticketListType === Constant.MENU_SELECT_TYPE.TICKET_LIST_HELP_DESK_SIDE
                );
            }
            if (Utils.isProjectGuestDesk(projectInuseDetail)) {
                return false;
            }
            if (
                projectInuseDetail.type === Constant.PROJECT_TYPE.BASE &&
                [
                    Constant.CORPORATION_CONTRACT_TYPE.GUEST,
                    Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
                ].includes(contractType)
            ) {
                return false;
            }
            return true;
        };
        
        setIsCreateTicket(isShowButtonCreateTicket());
    }, [userDetail.userType, props.ticketListType]);

    const getNextPageQaList = () => {
        const from = ticketFrom + Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD;
        setIsScrollLoad(false);
        setTicketFrom(from);
        getTicketLists(true, from);
    }

    const getValueQAViewName = (view) => {
        let viewName = LogKibanaConstant.QA_VIEW_NAME.IN_CHARGE_QA_VIEW;
        switch (view) {
            case Constant.CUSTOMER_SIDE_VIEW.IN_CHARGE_QA_VIEW:
                viewName = LogKibanaConstant.QA_VIEW_NAME.IN_CHARGE_QA_VIEW;
                break;
            case Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW:
                viewName = LogKibanaConstant.QA_VIEW_NAME.NOTICE_VIEW;
                break;
            case Constant.CUSTOMER_SIDE_VIEW.DRAFT_QA_VIEW:
                viewName = LogKibanaConstant.QA_VIEW_NAME.DRAFT_QA_VIEW;
                break;
            case Constant.CUSTOMER_SIDE_VIEW.ARCHIVE_QA_VIEW:
                viewName = LogKibanaConstant.QA_VIEW_NAME.ARCHIVE_QA_VIEW;
                break;
            case Constant.CUSTOMER_SIDE_VIEW.INVITATION_VIEW:
                viewName = LogKibanaConstant.QA_VIEW_NAME.INVITATION_VIEW;
                break;
            case Constant.CUSTOMER_SIDE_VIEW.TELEPHONE_VIEW:
                viewName = LogKibanaConstant.QA_VIEW_NAME.TELEPHONE_VIEW;
                break;
            default:
                break;
        }
        return viewName;
    }

    const getTicketLists = async (loading = true, from = 0, size = null) => {
        if (loading) setIsLoading(true);
        let lastUserAction = LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE;
        let filterInput = {
            affiliationOrganization: localStorageUtil.getAffiliationOrganization(),
            affiliationProject: projectInuseDetail.id
        }
        let keywordList = [];
        let tagSuggestList = [];
        let operationScreen = LogKibanaConstant.OPERATION_SCREEN.SOLUTION_DESK;
        let inforSearch = {
            viewName: getValueQAViewName(viewSelected),
            viewKeyword: '',
            viewKeywordCondition: '',
            viewSearchTarget: '',
            viewDateType: '',
            viewDateFrom: '',
            viewDateTo: '',
            viewDateTerm: '',
            viewDateUnit: '',
            viewOrTag: '',
            viewExceptTag: '',
            viewTag: '',
            viewSort: '',
        }

        let searchContentTypeClone = LogKibanaConstant.CONTENT_TYPES_TICKET.QA;

        if(viewSelected === Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW) {
            searchContentTypeClone = LogKibanaConstant.CONTENT_TYPES_TICKET.NOTICE
        }
        
        let logKibanaData = createKibanaData(
            lastUserAction,
            filterInput,
            keywordList,
            corporationDetail,
            projectInuseDetail,
            userDetail,
            searchContentTypeClone,
            operationScreen,
            tagSuggestList,
            inforSearch
        );

        let queryParams = {
            viewType: viewSelected,
            ticketListType: props.ticketListType,
            corporationId: localStorageUtil.getAffiliationOrganization(),
            projectId: projectInuseDetail.id,
            userId: userDetail.id,
            filterStatus: filterStatus,
            filterCreator: filterCreator,
            filterHelpDesk: filterHelpDesk,
            filterHelpDeskNotice: filterHelpDeskNotice,
            filterTelephonePublisher: filterTelephonePublisher,
            from: from,
            size: size ? size : Constant.TICKET_LIST_PAGINATION_DEFAULT_RECORD,
            logKibanaData: size ? '' : JSON.stringify(logKibanaData)
        };
        
        getTicketListQuery(props?.API, queryParams)
            .then(queryResult => {
                let listTicket = queryResult.responseTicketList
                    ? queryResult.responseTicketList
                    : [];
                
                listTicket = Utils.sortByUpdatedAtDesc(listTicket);
                listTicket = listTicket.filter(item => Utils.isEmptyString(item.deletedAt));

                setLastedCountList(listTicket.length);
                setHelpDeskListIdInView(listTicket);

                let mergeTicketList = (from > 0) ? ticketList?.concat(listTicket) : listTicket;

                setTicketList(mergeTicketList);
                setTotalTickets(queryResult.totalTickets);
                let helpDeskListResult = queryResult.responseHelpDeskList
                    ? queryResult.responseHelpDeskList
                    : [];
                
                setHelpDeskList(helpDeskListResult);

                setIsLoading(false);
            })
            .catch(error => {
                setTicketList([]);
                setHelpDeskList([]);
                setIsLoading(false);
            });
    };

    const setHelpDeskListIdInView = listTicket => {
        let helpDeskListId = [];

        // Check if current view is NOTICE_VIEW or TELEPHONE_VIEW and filter is not applied
        const isNoticeView =
            viewSelected === Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW && filterHelpDeskNotice === '';
        const isTelephoneView =
            viewSelected === Constant.CUSTOMER_SIDE_VIEW.TELEPHONE_VIEW &&
            filterTelephonePublisher === '';

        if (!isNoticeView && !isTelephoneView) {
            return;
        }

        const ticketListLength = listTicket.length;
        if (ticketListLength === 0) {
            setHelpDeskListInView([]);
            return;
        }

        for (let i = 0; i < ticketListLength; i++) {
            let ticket = listTicket[i];
            if (ticket.projectOrigin && !helpDeskListId.includes(ticket.projectOrigin)) {
                helpDeskListId.push(ticket.projectOrigin);
            }
        }

        // only update when in view notice/telephone and select all
        if (helpDeskListId.length > 0) {
            setHelpDeskListInView(helpDeskListId);
        }
    };

    return (
        <div className="mainWrap">
            <LoadingPanel isLoading={isLoading} />
            <div className="mainTop">
                <div className="mainFlex">
                    <div className="col2">
                        <ViewTabs
                            isCreateTicket={isCreateTicket}
                            panelId={props.panelId}
                            API={props?.API}
                            isAtTicketDetail={false}
                            fileUploading={fileUploading}
                            setFileUploading={setFileUploading}
                            setIsLoading={setIsLoading}
                            ticketListType={props.ticketListType}
                            viewSelected={viewSelected}
                            setViewSelected={setViewSelected}
                            filterStatus={filterStatus}
                            setFilterStatus={setFilterStatus}
                            filterCreator={filterCreator}
                            setFilterCreator={setFilterCreator}
                            filterHelpDesk={filterHelpDesk}
                            setFilterHelpDesk={setFilterHelpDesk}
                            // filter notice
                            setFilterHelpDeskNotice={setFilterHelpDeskNotice}
                            // filter telephone
                            setFilterTelephonePublisher={setFilterTelephonePublisher}

                            isProjectManager={isProjectManager}
                        />
                    </div>
                </div>
            </div>

            <div className="main-filter">
                {/* {viewSelected !== Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW && */}
                {viewSelected !== Constant.CUSTOMER_SIDE_VIEW.INVITATION_VIEW && (
                        <Filters
                            viewSelected={viewSelected}
                            setViewSelected={setViewSelected}
                            projectInuseDetail={projectInuseDetail}
                            filterStatus={filterStatus}
                            setFilterStatus={setFilterStatus}
                            filterCreator={filterCreator}
                            setFilterCreator={setFilterCreator}
                            filterHelpDesk={filterHelpDesk}
                            setFilterHelpDesk={setFilterHelpDesk}
                            // filter notice
                            filterHelpDeskNotice={filterHelpDeskNotice}
                            setFilterHelpDeskNotice={setFilterHelpDeskNotice}
                            helpDeskList={helpDeskList}
                            helpDeskListInView={helpDeskListInView}
                            // filter telephone
                            filterTelephonePublisher={filterTelephonePublisher}
                            setFilterTelephonePublisher={setFilterTelephonePublisher}
                        />
                    )}
            </div>
            {
                !Utils.isEmptyArray(ticketList) && 
                <div className="searchCondition searchCondition-background">
                    <div className="searchCondition-item" >
                        <span className='option-name '><strong>検索結果：{totalTickets}件</strong></span>
                    </div>
                </div>
            }
            <div className="mainFlex">
                <div className="col2">
                    {Utils.isEmptyArray(ticketList) ? (
                        <div className="listEmpty listEmpty-qa" data-cy="label-ticket-list-empty">
                            <span className='listEmpty-item'>
                                <img src="/assets/image/icon-listEmpty.svg" alt="" />
                            </span>
                            {I18n.get('COMMSG001')}
                        </div>
                    ) : (
                        <ListTicket
                            API={props?.API}
                            ticketListType={props.ticketListType}
                            ticketList={ticketList}
                            setTicketList={setTicketList}
                            viewStructure={props.viewStructure}
                            setViewStructure={props.setViewStructure}
                            setTriggerSearch={props.setTriggerSearch}
                            setOptionSearchTime={props.setOptionSearchTime}
                            defaultDrillDownData={props.defaultDrillDownData}
                            inputKeyWordRef={props.inputKeyWordRef}
                            lastedCountList={lastedCountList}
                            setLastedCountList={setLastedCountList}
                            fromTicket={props.fromTicket}
                            setFromTicket={props.setFromTicket}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            keywordSearch={props.keywordSearch}
                            setKeywordSearch={props.setKeywordSearch}
                            setDrillDownDataSelected={props.setDrillDownDataSelected}
                            projectUserList={props.projectUserList}
                            panelId={props.panelId}
                            setIsLoadingDrillDown={props.setIsLoadingDrillDown}
                            setDrillDownData={props.setDrillDownData}
                            setSugguestionList={props.setSugguestionList}
                            setDefaultDrillDownData={props.setDefaultDrillDownData}
                            getNextPageQaList={getNextPageQaList}
                            isScrollLoad={isScrollLoad}
                            setTotalTickets={setTotalTickets}
                            panelType={props.panelType}
                            setHelpDeskListInView={setHelpDeskListInView}
                            setFilterHelpDeskNotice={setFilterHelpDeskNotice}                            
                            triggerInterval={triggerInterval}
                        />
                    )}
                </div>
            </div>

            <ErrorModal
                open={isModalUploadFileError}
                message={`${fileUploading?.file?.name} ${I18n.get('USER04MSG004')}`}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
                title={'Upload fail'}
            ></ErrorModal>
        </div>
    );
}
